import TC from "@/components/table/Table.module.css";

import { mcn, type BaseProps } from "@/utils/baseProps.ts";
import { cn } from "@/utils/classNames.ts";
import type { ReactNode } from "react";

export interface DetailsTableProps extends BaseProps {
    children?: ReactNode;
    compact?: boolean;
}

export function DetailsTable({ children, compact, ...props }: DetailsTableProps) {
    return (
        <table {...mcn(cn(TC.details, compact && TC.compact), props)}>
            <tbody>{children}</tbody>
        </table>
    );
}

export function DetailsHolder({ children }: { children: ReactNode }) {
    return <div className={TC.detailsHolder}>{children}</div>;
}
